<!---Start brand popup to go to live offers for service provider only---->
<div class="basic-info-popup" *ngIf="!_as?.isOnMobilePlatform">
    <p-dialog [(visible)]="_as.isBrandLiveOffers" [modal]="true" [baseZIndex]="10000" [showHeader]="false"
      [closable]="false">
      <div>
        <div class="close-popup" (click)="_as.isBrandLiveOffers = false" style="right: 13px;top: 11px;cursor: pointer;">
          <img ngOptimizedImage alt=" close icon" src="https://res.cloudinary.com/afterbricks/image/upload/v1643650270/icons/close_nqzrnn.svg">
        </div>
        <div class="ab-modal-heading">
          <h3>Select by brand</h3>
          <p>Click below and continue</p>
        </div>
          <ul class="ab-modal-body-ul" *ngIf="!_project.isLoadingData">
            <li class="ab-modal-body-card" style="height: fit-content !important;" 
                *ngFor="let brand of _as.compareOffers;" (click)="_project.onBrandSelect(brand)">
              <div class="ab-modal-body-img">
                <img ngOptimizedImage *ngIf="brand?.brand_logo" [src]="brand?.brand_logo" [alt]="brand?.brand_name">
              </div>
              <div class="ab-modal-dept-name">
                {{brand?.department?.name}}
              </div>
            </li>
          </ul>
        <ul class="ab-modal-body-ul is-loading" *ngIf="_project.isLoadingData">
          <li class="ab-modal-body-card" *ngFor="let brand of [1,2,3,4];">
            <div class="ab-modal-body-img product-img-1">
            </div>
            <div class="ab-modal-dept-name name">
            </div>
          </li>
        </ul>
      </div>
    </p-dialog>
  </div>
  
  <div class="basic-info-popup m-block" *ngIf="_as?.isOnMobilePlatform">
    <p-sidebar [(visible)]="_as.isBrandLiveOffers" position="bottom" [modal]="true" [baseZIndex]="10000">
      <div class="close-popup" (click)="_as.isBrandLiveOffers=false" style="display: block;">
        <img ngOptimizedImage src="https://res.cloudinary.com/afterbricks/image/upload/v1643650270/icons/close_nqzrnn.svg" alt="close icon"
          loading="lazy">
      </div>
  
      <div class="ab-modal-heading">
        <h3>Select by brand</h3>
      </div>
      <div class="row">
        <ul class="ab-modal-body-ul" *ngIf="!_project.isLoadingData">
          <li class="ab-modal-body-card" *ngFor="let brand of _as.compareOffers;" (click)="this._project.onBrandSelect(brand)">
            <div class="ab-modal-body-img">
              <img ngOptimizedImage  *ngIf="brand?.brand_logo" [src]="brand?.brand_logo" [alt]="brand?.brand_name">
            </div>
            <div class="ab-modal-dept-name">
              {{brand?.department?.name}}
            </div>
          </li>
        </ul>
        <ul class="ab-modal-body-ul is-loading" *ngIf="_project.isLoadingData">
          <li class="ab-modal-body-card" *ngFor="let brand of [1,2];">
            <div class="ab-modal-body-img product-img-1">
            </div>
            <div class="ab-modal-dept-name name">
            </div>
          </li>
        </ul>
      </div>
    </p-sidebar>
  </div>
  <!---End brand popup to go to live offers for service provider only---->
